import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { server } from "../server";
import { getUserIdFromToken } from "../utils/auth";

export const fetchMyProfile = createAsyncThunk(
  "myProfile/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const userId = await getUserIdFromToken();

      const response = await fetch(
        `${server}/profile/GetProfileById?id=${userId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch profile");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const myProfileSlice = createSlice({
  name: "myProfile",
  initialState: {
    profile: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(fetchMyProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default myProfileSlice.reducer;
